export default function UserMessage({ content, index }: { content: string, index:number }) {
  return (
    <div id={`user-message-${index}`} className="mr-4 p-4 rounded-md border shadow-md  bg-pipgrey-md self-end max-w-[75%]">
      <p className="text-piptext">{content}</p>
    </div>
  );
}
